import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGavel, faClipboardList, faArrowRight } from '@fortawesome/free-solid-svg-icons';


// Styled-components 정의
const MessageRow = styled.tr`
  text-align: center;
`;

const MessageTd = styled.td`
  padding: 100px;
  font-size:18pt;
  font-style: italic;
  cursor:pointer;
    &:hover {
      background-color:#f2f2f2;
  }
`;

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h2`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: white;
  overflow: hidden;
`;

const Th = styled.th`
  background-color:#f2f2f2;
  color: black;
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  font-size:14px;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
`;

const TimerTd = styled(Td)`
  color: ${(props) => (props.isCritical ? 'red' : 'black')};
`;

const Button = styled.button`
  padding: 8px 3px;
  margin: 6px;
  font-size: 14px;
  color: white;
  background-color: #007BFF;
  border: none;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const Message = styled.div`
  position: absolute;
  top: -150px;
  left: 50%;
  transform: translateX(-50%);
  padding: 15px;
  text-align: center;
  color: ${(props) => (props.success ? 'green' : 'red')};
  background-color: ${(props) => (props.success ? '#e6ffe6' : '#ffe6e6')};
  border: 1px solid ${(props) => (props.success ? 'green' : 'red')};
  border-radius: 5px;
  width: 100%;
  max-width: 600px;
`;
const CountsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const CountBox = styled.div`
  color: #black;
  border: 1px;
  border-style: double;
  padding: 30px;
  border-radius: 10px;
  flex: 1;
  text-align: center;
  margin: 0 10px;
  border-color:#dddddd;
  &:first-child {
    margin-left: 0;
  }
  
  &:last-child {
    margin-right: 0;
  }
`;

const CountNumber = styled.div`
  font-size: 58px;
  font-weight: bold;
`;
const IconLabel = styled.div`
font-size: 18pt;
    padding: 10px;
    font-weight: bold;
`;
const CountLabel = styled.div`
  font-size: 18px;
  margin-top: 10px;
`;
const statusDisplay = (status) => {
  switch (status) {
    case "public_reaction":
      return "재경매";
    case "public_action":
      return "경매";
    case "reassigned":
      return "재할당";
    case "canceled":
      return "취소";
    case "assigned":
      return "할당";
    case "requested":
      return "요청 중";
    case "awarded":
      return "낙찰됨";
    case "last_action":
        return "마감경매";
    case "last_awarded":
        return "마감 낙찰됨";
    case "completed":
      return "대행완료";
    default:
      return status;
  }
};
// OrderRow 컴포넌트를 AssignedOrders 컴포넌트 밖으로 이동
const OrderRow = ({
  order,
  handleCancelAssignment,
  handleExtenderTime,
  handleOrderProcessed,
  calculateRemainingTime,
}) => {
  const [completeCode, setCompleteCode] = useState('');
  const [remainingTime, setRemainingTime] = useState(
    order.remainingTime || calculateRemainingTime(order.expiration_time)
  );
  const [couponCode, setCouponCode] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newRemainingTime = calculateRemainingTime(order.expiration_time);
      setRemainingTime(newRemainingTime);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [order.expiration_time, calculateRemainingTime]);

  const isCritical =
    remainingTime &&
    remainingTime.split(':')[0] === '0' &&
    parseInt(remainingTime.split(':')[1]) <= 2;

  // fetchOrderDetails 함수 수정
  const fetchOrderDetails = async (menu_id) => {
    try {
      const response = await fetch(
        `/Acution/order-details/${menu_id}`,
        {
          credentials: 'include',
        }
      );
      const data = await response.json();
      if (data) {
        console.log('쿠폰코드: ' + data.coupon_code);
        setCouponCode(data.coupon_code); // 상태 업데이트
        return data.coupon_code; // 쿠폰 코드 반환
      }
    } catch (error) {
      console.error('Error fetching order details:', error);
    }
    return null; // 에러 발생 시 null 반환
  };

  // handleSubmit 함수 수정
  const handleSubmit = async () => {
    // [2026-07-16] 발권정보가 비어 있으면 대행진행 차단(빈 발권으로 완료되어 고객이 예매정보 못 보는 문제 방지)
    if (!completeCode || !completeCode.trim()) {
      alert('발권정보에 내용이 없습니다.');
      return;
    }

    let code = couponCode;
    if (!code) {
      // 쿠폰 코드를 먼저 가져옵니다.
      code = await fetchOrderDetails(order.menu_id);
    }

    if (!code) {
      alert('쿠폰 코드를 불러오는 중입니다. 잠시 후 다시 시도해주세요.');
      return;
    }

    // completeCode의 엔터(\n)를 <br/> 태그로 변환
    const formattedCompleteCode = completeCode.replace(/\n/g, '<br/>');

    try {
      const response = await fetch('/Acution/process-order', {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          menu_id: order.menu_id,
          coupon_code: code, // 변경된 부분
          complate_code: formattedCompleteCode,
        }),
      });

      if (response.ok) {
        alert('주문이 성공적으로 처리되었습니다.');
        // 처리된 주문을 목록에서 제거합니다.
        handleOrderProcessed(order.menu_id);

        // 처리 후 OrderHistory로 이동합니다.
        navigate('/Tiketting/OrderHistory');
      } else {
        const errorData = await response.json();
        if (errorData.error === 'Insufficient points balance to process the order.') {
          alert('포인트 잔액이 부족합니다. 충전 후 다시 시도해주세요.');
        } else {
          alert(
            `주문 처리에 실패했습니다. 서버 응답: ${
              errorData.error || '입력 정보를 확인해주세요.'
            }`
          );
        }
      }
    } catch (error) {
      console.error('Error processing the order:', error);
    }
  };

  return (
    <tr key={order.menu_id}>
      
      <Td>{statusDisplay(order.agent_status)}</Td>
      <Td>{order.menu_id}</Td>
      <Td>{order.price}</Td>
      <Td colSpan={6}>
        {order.movie_title +
          '/' +
          order.theater +
          '/' +
          order.date +
          '/' +
          order.screening_time +
          '/' +
          order.seat_info +
          ' / ' +
          (order.viewer_count || '정보없음') + '명'}
      </Td>
      <TimerTd isCritical={isCritical}>
        {remainingTime || calculateRemainingTime(order.end_time)}
      </TimerTd>
      <Td>{order.extensionCount}</Td>
      <Td
        style={{
          padding: '0px 7px 0px 0px',
          margin: '0px',
          width: '14rem',
          minWidth: '14rem',
        }}
      >
        <textarea
          style={{ width: '100%', height: '100%', resize: 'both' }}
          value={completeCode}
          onChange={(e) => setCompleteCode(e.target.value)}
        ></textarea>
      </Td>
      {/* [2026-07-16] 버튼 3개(대행진행/할당취소/시간연장)를 한 줄로: 셀 폭 확보 + nowrap로 줄바꿈 방지 */}
      <Td style={{ minWidth: '18rem', whiteSpace: 'nowrap' }}>
        <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '4px', justifyContent: 'center' }}>
          <Button type="button" style={{ whiteSpace: 'nowrap', margin: 0 }} onClick={handleSubmit}>
            대행진행
          </Button>
          <Button type="button" style={{ whiteSpace: 'nowrap', margin: 0 }} onClick={() => handleCancelAssignment(order.menu_id, completeCode)}>
            할당취소
          </Button>
          <Button
            type="button"
            style={{ whiteSpace: 'nowrap', margin: 0 }}
            onClick={() => handleExtenderTime(order.menu_id)}
            disabled={order.extensionCount >= 2} // 연장 횟수가 2 이상이면 버튼 비활성화
          >
            시간연장
          </Button>
        </div>
      </Td>
    </tr>
  );
};

const AssignedOrders = () => {
  const [orderCount, setOrderCount] = useState(0);
const [auctionCount, setAuctionCount] = useState(0);
  const [orders, setOrders] = useState([]);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
    useEffect(() => {
      let intervalId;
    
      const fetchCounts = async () => {
        try {
          const response = await fetch('/Acution/order-counts', {
            credentials: 'include',
          });
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.json();
          setOrderCount(data.orderCount);
          setAuctionCount(data.auctionCount);
        } catch (err) {
          console.error('주문 및 경매 건수 가져오는 중 오류 발생:', err);
        }
      };
    
      fetchCounts();
      intervalId = setInterval(fetchCounts, 60000); // 1분마다 갱신
    
      return () => clearInterval(intervalId); // 컴포넌트 언마운트 시 인터벌 제거
    }, []);
  const fetchExtensionCount = async (menu_id) => {
    try {
      const response = await fetch(
        `/Acution/extension-count/${menu_id}`,
        {
          credentials: 'include',
        }
      );
      if (response.ok) {
        const data = await response.json();
        return data.extension_count || 0;
      } else {
        console.error(`Failed to fetch extension count for menu_id ${menu_id}`);
        return 0;
      }
    } catch (error) {
      console.error(`Error fetching extension count for menu_id ${menu_id}:`, error);
      return 0;
    }
  };

  const fetchAssignedOrders = async () => {
    try {
      const response = await fetch('/Acution/assigned-orders', {
        credentials: 'include',
      });
      const data = await response.json();
      //console.log('서버에서 받은 데이터:', data);

      if (data && data.length > 0) {
        // 각 주문의 연장 횟수를 조회하여 주문 정보에 추가
        const ordersWithExtensionCounts = await Promise.all(
          data.map(async (order) => {
            const extensionCount = await fetchExtensionCount(order.menu_id);
            return {
              ...order,
              remainingTime: calculateRemainingTime(order.expiration_time),
              extensionCount,
            };
          })
        );
        setOrders(ordersWithExtensionCounts);
      } else {
        setOrders([]);
        setMessage({ type: 'info', text: '현재 할당된 대행 건 수가 없습니다.' });
      }
    } catch (error) {
      console.error('Error fetching assigned orders:', error);
      setMessage({ type: 'error', text: '주문 데이터를 가져오는 중 오류가 발생했습니다.' });
      navigate('/login');
    }
  };

  const handleCancelAssignment = async (menu_id, completeCode) => {
    // 할당취소 사유 선택 다이얼로그
    const cancelReason = window.prompt(
      '할당취소 사유를 선택해주세요:\n' +
      '1. 예매좌석매진\n' +
      '2. 특별관 예매불가\n' +
      '3. 상영시간없음\n' +
      '4. 개인사정 (벤 처리)\n\n' +
      '숫자를 입력하세요 (1-4):',
      '1'
    );

    // 취소 버튼 누르면 종료
    if (cancelReason === null) {
      return;
    }

    // 사유 코드 매핑
    const reasonMap = {
      '1': 'sold_out',
      '2': 'special_seat',
      '3': 'no_showtime',
      '4': 'personal'
    };

    const selectedReason = reasonMap[cancelReason.trim()];

    if (!selectedReason) {
      alert('올바른 번호를 선택해주세요 (1-4)');
      return;
    }

    try {
      const response = await fetch('/Acution/cancel-assignment', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          menu_id,
          complate_code: completeCode || '', // 발권정보 포함
          cancel_reason: selectedReason // 취소 사유 추가
        }),
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to cancel assignment');
      }

      const reasonText = {
        'sold_out': '예매좌석매진',
        'special_seat': '특별관 예매불가',
        'no_showtime': '상영시간없음',
        'personal': '개인사정'
      };

      alert(`할당이 취소되었습니다. (사유: ${reasonText[selectedReason]})`);
      setOrders((prevOrders) => prevOrders.filter((order) => order.menu_id !== menu_id));
    } catch (error) {
      alert('할당 취소 중 오류가 발생했습니다: ' + error.message);
    }
  };

  const handleExtenderTime = async (menu_id) => {
    try {
      const response = await fetch('/Acution/extend-assignment', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ menu_id }),
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to extend assignment');
      }

      alert('할당시간이 연장되었습니다.');
      // 시간 연장 후 할당된 주문 데이터를 다시 가져옵니다.
      await fetchAssignedOrders();
    } catch (error) {
      alert('할당 연장 중 오류가 발생했습니다: ' + error.message);
    }
  };

  const handleOrderProcessed = (menu_id) => {
    setOrders((prevOrders) => prevOrders.filter((order) => order.menu_id !== menu_id));
  };

  useEffect(() => {
    fetchAssignedOrders();
  }, []);

  useEffect(() => {
    if (orders.length === 0) {
      setMessage({ type: 'info', text: '현재 할당된 대행 건 수가 없습니다.' });
    }
  }, [orders]);

  const calculateRemainingTime = (expirationTime) => {
    if (!expirationTime) {
      return null; // 만료 시간이 없으면 'null'을 반환하여 만료된 것으로 처리하지 않음
    }

    const end = new Date(expirationTime);
    const now = new Date();
    const diff = end - now;

    if (diff <= 0) {
      return 'Expired';
    }

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <Container>
      {message && <Message success={message.type === 'success'}>{message.text}</Message>}
      {/* <Title>할당된 대행주문건</Title> */}
      <CountsContainer>
      <CountBox>
      <section>
        <FontAwesomeIcon icon={faClipboardList} size="2x" /><IconLabel>대행</IconLabel>
      </section>
        <CountNumber>{orderCount}</CountNumber>
        <CountLabel>현재 진행 중인 대행 건수</CountLabel>
      </CountBox>
      <CountBox>
      <section>
      <FontAwesomeIcon icon={faGavel} size="2x" /><IconLabel>경매</IconLabel>
        </section>
        <CountNumber>{auctionCount}</CountNumber>
        <CountLabel>현재 진행 중인 경매 건수</CountLabel>
      </CountBox>
    </CountsContainer>

      <Table>
        <thead>
          <tr>
            <Th>구분</Th>
            <Th>주문 번호</Th>
            <Th>대행금액</Th>
            <Th colSpan={6}>영화제목 / 상영관 / 상영일자 / 상영시간 / 좌석 정보 / 인원수</Th>
            <Th>타임아웃</Th>
            <Th>연장횟수</Th>
            <Th>발권정보</Th>
            <Th>입찰진행</Th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
          <MessageRow>
          <MessageTd onClick={()=>navigate('/Tiketting/UserOptions')} colSpan="14">
                현재 할당된 대행 건 수가 없습니다. 대행옵션 바로가기
          </MessageTd>
        </MessageRow>
            
          ) : (
            orders.map((order) => (
              <OrderRow
                key={order.menu_id}
                order={order}
                handleCancelAssignment={handleCancelAssignment}
                handleExtenderTime={handleExtenderTime}
                handleOrderProcessed={handleOrderProcessed}
                calculateRemainingTime={calculateRemainingTime} // 함수 전달
              />
            ))
          )}
        </tbody>
      </Table>
           {/* 경매 및 주문 건수 표시 */}

    {/* <OptionButton onClick={() => navigate('/Auction/Options')}>
                경매대행 옵션설정 바로가기
              </OptionButton> */}
    </Container>
  );
};

export default AssignedOrders;
